var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 26,
    viewBox: "0 0 34 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 26V18.8481C0 16.7373 0.397225 14.5148 1.19168 12.1805C1.98613 9.84622 3.09091 7.61127 4.50602 5.47564C5.92114 3.34002 7.58452 1.5148 9.49617 0L15.0077 3.94842C13.4932 6.15854 12.2023 8.468 11.1347 10.8768C10.0672 13.2856 9.53341 15.9054 9.53341 18.7364V26H0ZM18.9923 26V18.8481C18.9923 16.7373 19.3896 14.5148 20.184 12.1805C20.9785 9.84622 22.0832 7.61127 23.4984 5.47564C24.9135 3.34002 26.5769 1.5148 28.4885 0L34 3.94842C32.4856 6.15854 31.1946 8.468 30.1271 10.8768C29.0595 13.2856 28.5257 15.9054 28.5257 18.7364V26H18.9923Z",
    fill: "#113359"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComma);
export default __webpack_public_path__ + "static/media/comma.fadd7d3a415aca7304a467ba71cce606.svg";
export { ForwardRef as ReactComponent };